let inventoryRouteMapper = {
    'vcenter' : 'vc',
    'resourcePool': 'resourcepool',
    'vm': 'vm',
    'datacenter': 'datacenter',
    'cluster': 'cluster',
    'computeResource': 'computeresource'
};
export default inventoryRouteMapper;



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-tree/inventory-route-mapper.ts